import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import groupList from '../../assets/json/groupList.json';
import orders from '../../assets/json/order.json';
import CustomTable from "../../layout/table";
import { Orderschema } from "../../types/page";

export default function OrdersPage() {
    const history = useHistory();
    let params = useParams<{ userId: string }>();
    const [data, setData] = useState<Orderschema[]>([])

    function transformGroupsList() {
      return groupList.map(({ id, batchNo }) => ({ id, name: batchNo }))
    }

    function handleLoadGroupItem(id: string) {
        if (!id) return;
        history.push(`/dashboard/${params?.userId}/orders/${id!}`);
        setData(orders)
    }

    function clearGroupSelection() {
        history.push(`/dashboard/${params?.userId}/orders`);
        setData([])
    }

    return (
        <Box paddingX='8' paddingBottom='4' paddingTop='0' width='100%'>
            <CustomTable 
                tableType="orders" 
                groupList={transformGroupsList()} 
                dataByGroup={data} 
                onGroupItemClick={handleLoadGroupItem}
                onGroupSelectionClear={clearGroupSelection}
            />
        </Box>
    )
}